import { createActionTypes } from 'utils/action/actionTypes';

export const CREATE_VOUCHER = createActionTypes('CREATE_VOUCHER');
export const FETCH_VOUCHERS = createActionTypes('FETCH_VOUCHERS');
export const GET_VOUCHER = createActionTypes('GET_VOUCHER');
export const DELETE_VOUCHER = createActionTypes('DELETE_VOUCHER');
export const UPDATE_VOUCHER = createActionTypes('UPDATE_VOUCHER');
export const VOUCHER_LOGS = createActionTypes('VOUCHER_LOGS');
export const DOWNLOAD_VOUCHER_LOGS = createActionTypes('DOWNLOAD_VOUCHER_LOGS');
